import { useState } from 'react'
import { Alert, Icon, toast } from '@/ui'
import { AcceptButton } from './Styles'

const AlertWithMutation = ({
  title,
  successText,
  t,
  description,
  mutation,
  onCancel,
  onSubmit,
  acceptButtonText,
  acceptedText,
  acceptIcon,
}) => {
  const [animationState, setAnimationState] = useState('initial')
  const getAlertStates = () => {
    if (animationState === 'done') {
      return {
        alertType: 'success',
        alertTitle: t('Success'),
        message: successText,
      }
    }
    if (animationState === 'error') {
      return {
        alertType: 'error',
        alertTitle: t('Error'),
        message: t('Whoops, something went wrong. Please try again'),
      }
    }
    return {
      alertType: 'warning',
      alertTitle: title,
      message: description,
    }
  }

  const { alertTitle, message, alertType } = getAlertStates()

  return (
    <Alert
      title={alertTitle}
      message={message}
      type={alertType}
      hideCancelButton={['done', 'error'].includes(animationState)}
      onCancel={onCancel}
      disabled={false}
      AcceptButton={() => (
        <AcceptButton
          done={animationState === 'done'}
          revealButton={animationState === 'revealButton'}
          accepted={animationState === 'accepted'}
          initial={animationState === 'initial'}
          disabled={['revealButton', 'accepted'].includes(animationState)}
          onClick={async () => {
            if (animationState === 'error') {
              return onCancel()
            }
            if (animationState !== 'done') {
              setAnimationState('accepted')
              setTimeout(() => {
                setAnimationState('revealButton')
              }, 150)
              try {
                await mutation()
                toast.success(successText)
                onSubmit()
              } catch (e) {
                setAnimationState('error')
              }
            }
          }}>
          {!['revealButton', 'done', 'error'].includes(animationState) && (
            <span>
              {acceptButtonText ?? t('Delete')}
              <Icon
                name={acceptIcon ? acceptIcon : 'icon-trash'}
                color="#fff"
              />
            </span>
          )}
          {animationState === 'revealButton' && <span>{acceptedText}</span>}
          {['done', 'error'].includes(animationState) && (
            <span>{t('Close')}</span>
          )}
        </AcceptButton>
      )}
    />
  )
}

export default AlertWithMutation
